/* Names and avatars of poll creators, actors and voters, from the roster and group members. */

import { getDisplayNameFromGroup } from '../../Helpers/Chat/ChatHelper';
import { getUserDetails, isLocalUser } from '../../Helpers/Chat/User';
import { i18n } from '../../localization/i18n';

/**
 * Display name of a participant; the viewer reads as "You".
 *
 * @param {string} userId User id or JID.
 * @returns {string} Name to show.
 */
export const getPersonName = userId => {
    if (!userId) return '';
    if (isLocalUser(userId)) return i18n.t('chat.detail.YOU');
    return getDisplayNameFromGroup(userId).nameToDisplay || userId;
};

/**
 * Display name of a participant, never "You": for sentences that word the viewer apart.
 *
 * @param {string} userId User id or JID.
 * @returns {string} Name to show.
 */
export const getOtherPersonName = userId => (userId ? getDisplayNameFromGroup(userId).nameToDisplay || userId : '');

/**
 * Name the initials avatar is built from; the viewer uses their own nickname, never "You".
 *
 * @param {string} userId User id or JID.
 * @returns {string} Name for the initials.
 */
export const getPersonAvatarName = userId => {
    if (!userId) return '';
    if (isLocalUser(userId)) return getUserDetails(userId)?.initialName || '';
    return getOtherPersonName(userId);
};

/**
 * Avatar image token of a participant.
 *
 * @param {string} userId User id or JID.
 * @returns {string} Image token, empty when the user has no photo.
 */
export const getPersonImage = userId => {
    const details = getUserDetails(userId) || {};
    return details.thumbImage || details.image || '';
};
